import React from 'react';

export default function Button(props) {
	const variant = props.variant;
	const color = props.color;
	const disabled = props.disabled;
	const className = props.className;

	return (
		<>
			{
				variant === 'cta-secondary' && props.onClick
					?
					<a
						disabled={disabled}
						className="cta-secondary | cursor-pointer"
						onClick={(e) => disabled ? e.stopPropagation() : props.onClick()}
					>
						{props.children}
					</a>
					:
					<>
						{
							variant === 'cta-ghost' && props.onClick && props.href
								?
								<a
									href={props.href}
									target={props.target}
									disabled={disabled}
									className="cta-ghost | display-flex align-items-center cursor-pointer"
									onClick={(e) => disabled ? e.stopPropagation() : props.onClick()}
								>
									{props.children}
									<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
										<path fill="currentColor" fill-rule="evenodd" clip-rule="evenodd" d="M16.422 6.7319C16.274 6.49881 15.965 6.42988 15.7319 6.57795C15.4988 6.72602 15.4299 7.035 15.578 7.26809C16.3614 8.50149 17.031 9.43762 17.8221 10.2448C18.2659 10.6976 18.7427 11.1047 19.2918 11.5H1C0.723858 11.5 0.5 11.7239 0.5 12C0.5 12.2761 0.723858 12.5 1 12.5H19.0921C18.5138 12.8859 18.0302 13.2917 17.6 13.7448C16.8125 14.5741 16.2263 15.5391 15.5609 16.7609C15.4288 17.0034 15.5184 17.307 15.7609 17.4391C16.0034 17.5712 16.307 17.4816 16.4391 17.2391C17.0978 16.0297 17.6329 15.1624 18.3251 14.4333C19.0102 13.7118 19.8717 13.103 21.2081 12.4548C21.2146 12.4518 21.2209 12.4487 21.2272 12.4455L22.0661 12.0392L21.2579 11.5715C21.2527 11.5684 21.2475 11.5654 21.2422 11.5625C20.0684 10.8827 19.2488 10.2719 18.5363 9.54488C17.8186 8.81258 17.1932 7.94596 16.422 6.7319Z"/>
									</svg>
								</a>
								:
								<>
									{
										props.href && props.onClick
											?
											<a
												style={{ textDecoration: "none" }}
												href={props.href}
												target={props.target}
												onClick={(e) => disabled ? e.stopPropagation() : props.onClick()}

												data-label={props.dataLabel}
												data-category={props.dataCategory}
												data-posizione={props.dataPosizione}
												data-filiale={props.dataFiliale}
												data-linkId={props.dataLinkId}
												data-param={props.dataParam}
												disabled={disabled}
												className={(disabled ? "Mui-disabled " : " ") + "button btn " + (variant === "contained" ? "MuiButton-contained" : "") + (color === "primary" ? "Primary" : color === "secondary" ? "Secondary" : "") + " " + (variant === "outlined" ? "MuiButton-outlined" : "") + " " + color + " " + disabled + " " + className}
											>
												{props.children}
											</a>
											:
											<>
												{
													props.href
														?
														<a
															style={{ textDecoration: "none" }}
															href={props.href}
															disabled={disabled}
															className={(disabled ? "Mui-disabled " : " ") + "button btn " + (variant === "contained" ? "MuiButton-contained" : "") + (color === "primary" ? "Primary" : color === "secondary" ? "Secondary" : "") + " " + (variant === "outlined" ? "MuiButton-outlined" : "") + " " + color + " " + disabled + " " + className}
															data-label={props.dataLabel}
															data-category={props.dataCategory}
															data-posizione={props.dataPosizione}
															data-filiale={props.dataFiliale}
															data-linkId={props.dataLinkId}
															data-param={props.dataParam}
														>
															{props.children}
														</a>

														:

														<>
															{
																props.onClick ?
																	<a
																		tabindex="0"
																		onKeyDown={(e) => disabled ? e.stopPropagation() : (e.key === 'Enter' ? props.onClick() : e.stopPropagation())}
																		onClick={(e) => disabled ? e.stopPropagation() : props.onClick()}
																		disabled={disabled}
																		className={(disabled ? "Mui-disabled " : " ") + "button btn " + (variant === "contained" ? "MuiButton-contained" : "") + (color === "primary" ? "Primary" : color === "secondary" ? "Secondary" : "") + " " + (variant === "outlined" ? "MuiButton-outlined" : "") + " " + color + " " + disabled + " " + className}
																	>
																		{props.children}
																	</a>
																	:
																	<a
																		disabled={disabled}
																		className={(disabled ? "Mui-disabled " : " ") + "button btn " + (variant === "contained" ? "MuiButton-contained" : "") + (color === "primary" ? "Primary" : color === "secondary" ? "Secondary" : "") + " " + (variant === "outlined" ? "MuiButton-outlined" : "") + " " + color + " " + disabled + " " + className}
																	>
																		{props.children}
																	</a>
															}
														</>
												}
											</>
									}
								</>
						}
					</>
			}
		</>
	);
}